import { render } from "./SidebarSection.vue?vue&type=template&id=521e4d2a&scoped=true"
import script from "./SidebarSection.vue?vue&type=script&lang=js"
export * from "./SidebarSection.vue?vue&type=script&lang=js"

import "./SidebarSection.vue?vue&type=style&index=0&id=521e4d2a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e4d2a"]])

export default __exports__